import { GridFilterModel, GridInputRowSelectionModel, GridPaginationModel, GridSortModel } from "@mui/x-data-grid-premium";
import { createSlice } from "@reduxjs/toolkit";
import RedPanikHastaListesiResponse from "src/models/RedPanik/RedPanikHastaListesiResponse";
import VwHastaislemRedpanikDTO from "src/models/RedPanik/VwHastaislemRedpanikDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { ApiResponse } from "src/services/core";

export type RedPanikHastaListesi = ApiResponse<Array<RedPanikHastaListesiResponse>> & {
    isFetching?: boolean;
    isLoading?: boolean;
};

export type RedPanikIslemListesi = ApiResponse<Array<VwHastaislemRedpanikDTO>> & {
    isFetching?: boolean;
    isLoading?: boolean;
};
interface IRedPanikSlice {
    open: boolean;

    hastaListActiveRow?: RedPanikHastaListesiResponse;
    hastaListData: RedPanikHastaListesi;
    hastaListPaginationModel: GridPaginationModel;
    hastaListSortModel: GridSortModel;
    hastaListFilterModel: GridFilterModel;

    islemListActiveRow?: VwHastaislemRedpanikDTO;
    islemListData: RedPanikIslemListesi;
    islemListPaginationModel: GridPaginationModel;
    islemListSortModel: GridSortModel;
    islemListFilterModel: GridFilterModel;
}
export const RedPanikSlice = createSlice<IRedPanikSlice, MapReducerPayloads<IRedPanikSlice, {
    setOpen: boolean;

    setHastaListActiveRow?: RedPanikHastaListesiResponse;
    setHastaListData: RedPanikHastaListesi;
    setHastaListPaginationModel: GridPaginationModel;
    setHastaListSortModel: GridSortModel;
    setHastaListFilterModel: GridFilterModel;

    setIslemListActiveRow?: VwHastaislemRedpanikDTO;
    setIslemListData: RedPanikIslemListesi;
    setIslemListPaginationModel: GridPaginationModel;
    setIslemListSortModel: GridSortModel;
    setIslemListFilterModel: GridFilterModel;
}>>({
    name: "redPanik",
    initialState: {
        open: false,

        hastaListActiveRow: new RedPanikHastaListesiResponse(),
        hastaListData: { data: [], isFetching: false, isLoading: true, },
        hastaListPaginationModel: { page: 0, pageSize: 100 },
        hastaListSortModel: [],
        hastaListFilterModel: { items: [] },

        islemListActiveRow: new VwHastaislemRedpanikDTO(),
        islemListData: { data: [], isFetching: false, isLoading: false, },
        islemListPaginationModel: { page: 0, pageSize: 100 },
        islemListSortModel: [],
        islemListFilterModel: { items: [] },
    },
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload;
        },

        setHastaListActiveRow: (state, action) => {
            state.hastaListActiveRow = action.payload;
        },
        setHastaListData: (state, action) => {
            state.hastaListData = action.payload;
        },
        setHastaListPaginationModel: (state, action) => {
            state.hastaListPaginationModel = action.payload;
        },
        setHastaListSortModel: (state, action) => {
            state.hastaListSortModel = action.payload;
        },
        setHastaListFilterModel: (state, action) => {
            state.hastaListFilterModel = action.payload;
        },

        setIslemListActiveRow: (state, action) => {
            state.islemListActiveRow = action.payload;
        },
        setIslemListData: (state, action) => {
            state.islemListData = action.payload;
        },
        setIslemListPaginationModel: (state, action) => {
            state.islemListPaginationModel = action.payload;
        },
        setIslemListSortModel: (state, action) => {
            state.islemListSortModel = action.payload;
        },
        setIslemListFilterModel: (state, action) => {
            state.islemListFilterModel = action.payload;
        },
    },
});